import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import { modalTypes } from 'Services/constants/modals';
import DevicePermissions from './component';

export default connect(null, (dispatch) => ({
  openDevicePermissionsModal: () => dispatch(actions.modalOpen({
    id: 'devicePermissions',
    type: modalTypes.CUSTOM,
  })),
}))(DevicePermissions);
